
import React from "react";
import styles from "./chatReplyInner.module.scss";
import moment from "moment";
import { excelFormats, getcontactDetail, imageFormat, mp3Formats, pdfFormats, pptFormats, videoFormat, wordFormats, zipFormats, gifFormat, strickerFormat, getdateFormat, urlify } from "../../../../base/utils";
import { ChatService } from "../../../../base/chatService";
import iconmusic from "../../../../styles/images/wave-thumbnail.svg";
import iconpdf from "../../../../styles/images/filepdf.svg";
import iconppt from "../../../../styles/images/fileppt.svg";
import iconword from "../../../../styles/images/fileword.svg";
import iconxls from "../../../../styles/images/fileexcel.svg";
import iconzip from "../../../../styles/images/filezip.svg";
import store from "../../../../context/store/store";
import iconotherformat from "../../../../styles/images/otherformat.svg";
import { SocketChatService } from "../../../../base/socketChatService";
import { userInfo } from "../../../../base/socketChatService/utils";
import { useSelector } from "react-redux";
import { chatwindowDetails, initialStateModel } from "../../../../models/model";
import _ from "lodash";
type replyMessageProps = {
  isBottom?: any;
  replyingMessage?: any;
}

export default function ChatReplyInner({ replyingMessage, isBottom }: replyMessageProps) {
  let { userdetails }: any = store.getState().loginReducer;
  let fileList = (replyingMessage?.message?.messageType === "IMAGE" || replyingMessage?.message?.messageType === "FILE") ? replyingMessage.message.body : "";
  let fromcaller: any = getcontactDetail(replyingMessage?.from);
  const chatSocketMessage = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  const chatWindowReducer: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const replyHighlight = () => {
    var  chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
    let dataRes:any = {chatId:replyingMessage?.chatId,"id":replyingMessage.id }
    chatService.Savehistory(dataRes);
    
    setTimeout(function () {
      ChatService.saveChatHighlight(true, replyingMessage);
    }, 1000);
  }
  var msgBody:any = ''; 
  var el: any = document.getElementById('hhh' + replyingMessage?.id)?.offsetHeight;
  
  if(replyingMessage?.message?.messageType === "TEXT" || replyingMessage?.message?.messageType === "AT_MENTION"){
    let msg = _.find(chatSocketMessage?.messageList, function(o) { return o.id === replyingMessage?.id });
    msgBody = msg!== undefined?  msg?.message?.body : replyingMessage?.message?.body; 
  }
  let hovertimestamp = replyingMessage.timestamp !== undefined ? getdateFormat(replyingMessage?.timestamp) : "";
  const mention_mem:Array<any> =chatWindowReducer?.chatWindowDetails?.teammembersdetails || [];

  if (replyingMessage?.message?.messageType === "AT_MENTION"){

  mention_mem.map((value:any)=>{
    const callerID = value?.caller_id.toString();
    var re = new RegExp(`${"@"+(callerID)}`, 'g');
    msgBody = msgBody.replace(re,
      '<span class="'+styles.atMention+'">@'+callerID+'</span>').replace(/<\/?a[^>]*>/g," ");
   
  });
}  

  return (

    <>

      {replyingMessage ? (
        <>
          <div className={`replyInnerBorder ${styles.borderLftSet} ${replyingMessage?.direction === 'IN'?"replyFromLeft":"replyFromright"}`}></div>
          <div className={styles.replySec} onClick={replyHighlight}>
            {/* <div className={styles.replyInnerHeader}> */}
            {/* <div className={styles.convMemName}><span>{fromcaller?.caller_id}</span></div> */}
            {/* <div className={styles.convTime}>{htimestamp}</div> */}
            {/* </div> */}
            <div className={styles.replyContent}>

            {replyingMessage?.message?.messageType !== "NOTE" &&<div className={styles.convMemName}>
                <span className={styles.userAName}>{userdetails?.sip_login_id === fromcaller?.sip_login_id ? "You" : fromcaller?.caller_id} <span className={styles.originalTime}>{hovertimestamp}</span></span>
                {(replyingMessage?.message?.messageType === "TEXT" || replyingMessage?.message?.messageType === "AT_MENTION") && <p className={styles.existtingText} dangerouslySetInnerHTML={{ __html: (msgBody) }}>

                </p>}
                {(replyingMessage?.message?.messageType === "FILE" || replyingMessage?.message?.messageType === "IMAGE") &&
                  <>
                    {fileList.text ? <p id={`hhh` + replyingMessage?.id} className={styles.existtingText} dangerouslySetInnerHTML={{ __html: fileList?.text }}></p> :
                      <span className={styles.fileType}>{
                        mp3Formats.indexOf(fileList?.fileType) !== -1 ? "Audio" :
                          zipFormats.indexOf(fileList?.fileType) !== -1 ? "Document" :
                            pdfFormats.indexOf(fileList?.fileType) !== -1 ? "Document" :
                              wordFormats.indexOf(fileList?.fileType) !== -1 ? "Document" :
                                pptFormats.indexOf(fileList?.fileType) !== -1 ? "Document" :
                                  videoFormat.indexOf(fileList?.fileType) !== -1 ? "Video" :
                                    gifFormat.indexOf(fileList?.fileType) !== -1 ? "GIF" :
                                      strickerFormat.indexOf(fileList?.fileType) !== -1 ? "Sticker" :
                                        imageFormat.indexOf(fileList?.fileType) !== -1 ? "Picture" :
                                          excelFormats.indexOf(fileList?.fileType) !== -1 ? "Document" : "Other"} </span>}

                  </>
                }


              </div>}


              {/* {(replyingMessage?.message?.messageType === "FILE") ?
                (imageFormat.indexOf(fileList?.fileType) !== -1
              || videoFormat.indexOf(fileList?.fileType) !== -1) ?
                  <ChatImageInner isBottom={isBottom} replyingMessage={fileList}/> :
                  <ChatFileInner replyingMessage={replyingMessage} />: null} */}
               {replyingMessage?.message?.messageType === "NOTE" &&  <div className={styles.notesReply}>
                  <span className={styles.fileName}>
                    <span className={styles.iconTask}></span>
                    <span>{replyingMessage?.message?.body?.summary}</span>
                  </span>
                  <span className={styles.fileDt}>Created on {replyingMessage?.message?.body?.lastModified
           && moment(new Date(parseInt(replyingMessage?.message?.body?.lastModified))).format('ll')}</span>
                </div> }
              <div className={`${el === undefined ? styles.sizeSM : el < 21 ? styles.sizeSM : (el < 41 && el > 21) ? styles.sizeMD : styles.sizeLG} ${styles.fileSec}`}>
                {replyingMessage?.message?.messageType === "IMAGE" &&
                  <img src={fileList.filePath} alt="" />}
                {/* <img src={fileList.filePath} alt=""/>     */}
                {/* <div className={styles.videoSec}>
                    <video className="videoFluid"  controls={true} preload="metadata">
                      <source src={replyingMessage?.filePath} type="video/mp4" />
                    </video>
                    <div className={styles.videoPlay}></div>
                  </div>    */}
                
                {(replyingMessage?.message?.messageType === "FILE") && videoFormat.indexOf(fileList?.fileType) === -1 &&
                  <div className={styles.fileSec}>
                    <img src={
                      mp3Formats.indexOf(fileList?.fileType) !== -1 ? iconmusic :
                        zipFormats.indexOf(fileList?.fileType) !== -1 ? iconzip :
                          pdfFormats.indexOf(fileList?.fileType) !== -1 ? iconpdf :
                            wordFormats.indexOf(fileList?.fileType) !== -1 ? iconword :
                              pptFormats.indexOf(fileList?.fileType) !== -1 ? iconppt :
                                imageFormat.indexOf(fileList?.fileType) !== -1 ? fileList.filePath :
                                  excelFormats.indexOf(fileList?.fileType) !== -1 ? iconxls : iconotherformat}
                      alt="filename" />
                  </div>}

                {videoFormat.indexOf(fileList?.fileType) !== -1 &&
                  <div className={styles.videoSec}>
                    <video className="videoFluid" controls={false} preload="metadata">
                      <source src={fileList.filePath} type="video/mp4" />
                    </video>
                    <div className={styles.videoPlay}></div>
                  </div>}

                {/* {((replyingMessage?.message?.messageType === "FILE" || replyingMessage?.message?.messageType === "IMAGE") 
                  && ( imageFormat.indexOf(fileList?.fileType) !== -1 || videoFormat.indexOf(fileList?.fileType) !== -1)) ?
                  <ChatImageInner isBottom={isBottom} replyingMessage={fileList}/> : replyingMessage?.message?.messageType === "FILE"?
                  <ChatFileInner replyingMessage={fileList} /> :
                  replyingMessage?.message?.messageType === "GEO" ?  <p>location </p>: null} */}
              </div>
            </div>
          </div>
        </>
      ) : null}

    </>
  );
};
